const config = {
    APP_URL: process.env.APP_URL || "https://indo368.idrplays.com",
    CURRENCY_SYMBOL: "RP",
    CURRENCY_ISO_CODE: "IDR",
    PAYMENT_GATEWAY_MCODE: process.env.REACT_APP_PAYMENT_GATEWAY_MCODE || "INDO368",
};
 
export default config;
